export const routes = {
  customer: '/customer',
  default: '/',
  giftCard: '/giftcard',
  loyaltyLegacy: '/loyalty-legacy',
  ctgLoyaltyTransaction: '/ctg-loyalty-transaction',
  ctgLoyalty: '/ctg-loyalty',
  hockeyChallenges: '/hockey-challenges',
  offersLD: '/offers-ld',
  offersTH: '/offers-th',
  offersV1: '/offers-v1',
  offersV2: '/offers-v2',
  orders: '/orders',
  releaseNotes: '/release-notes',
  rollUpTheRim: '/roll-up-the-rim',
  history: '/history',
  signIn: '/signin',
  store: '/store',
  supportHistory: '/support-history',
  thLoyaltyLegacy: '/th-loyalty-legacy',
  thLoyalty: '/th-loyalty',
  thLoyaltyTransaction: '/th-loyalty-transaction',
  expiringPoints: '/expiring-points',
  triangleRewards: '/triangle-rewards',
  fsTransactions: '/fs-transactions',
};

export const nestedResources = {
  [routes.customer]: [
    routes.giftCard,
    routes.ctgLoyalty,
    routes.hockeyChallenges,
    routes.offersLD,
    routes.offersTH,
    routes.offersV1,
    routes.offersV2,
    routes.orders,
    routes.supportHistory,
  ].map((resource) => resource.replace('/', '')),
};

export const isRouteSelected = (route: string, pathName: string) => {
  // This function is not an exact science
  // One day we will migrate to React Router and use https://v5.reactrouter.com/web/api/matchPath
  // Until the this appears to be the best we can do...
  const routeResource = route.replace('/', '');
  const pathParts = pathName.split('/').filter(Boolean);
  const firstPathPart = `/${pathParts[0]}`;
  const lastPathPart = pathParts.slice(-1)[0];
  const isCurrentPathNestedResource = !!nestedResources[firstPathPart]?.includes(lastPathPart);
  if (isCurrentPathNestedResource) {
    // we want the offers tab to remain selected whether the agent is viewing offers v1 or v2
    if (lastPathPart.startsWith('offers')) {
      return routeResource.includes('offers');
    }
    // all other nested resources
    return lastPathPart === routeResource;
  }
  if (pathParts.length === 4) {
    // special case for double nested orders route: customers/:customerId/orders/:orderId
    return pathParts[2] === routeResource;
  }
  if (route === routes.giftCard) {
    return firstPathPart === route || lastPathPart === routeResource;
  }
  if (pathParts.length === 1 || pathParts.length === 2) {
    return firstPathPart === route;
  }
};

export const expandPath = (resource: string, params: Record<string, string>) => {
  const { customerId = '', storeId = '', orderId = '' } = params;
  if (resource === routes.customer && !!customerId) {
    return `${routes.customer}/${customerId}`;
  }
  if (resource === routes.ctgLoyalty && !!customerId) {
    return `${routes.customer}/${customerId}${routes.ctgLoyalty}`;
  }
  if (resource === routes.hockeyChallenges && !!customerId) {
    return `${routes.customer}/${customerId}${routes.hockeyChallenges}`;
  }
  if (resource === routes.orders && !!customerId && !orderId) {
    return `${routes.customer}/${customerId}${routes.orders}`;
  }
  if (resource === routes.orders && !!customerId && !!orderId) {
    return `${routes.customer}/${customerId}${routes.orders}/${orderId}`;
  }
  if (resource === routes.fsTransactions && !!customerId) {
    return `${routes.customer}/${customerId}${routes.fsTransactions}`;
  }
  if (resource === routes.offersLD && !!customerId) {
    return `${routes.customer}/${customerId}${routes.offersLD}`;
  }
  if (resource === routes.offersV1 && !!customerId) {
    return `${routes.customer}/${customerId}${routes.offersV1}`;
  }
  if (resource === routes.offersV2 && !!customerId) {
    return `${routes.customer}/${customerId}${routes.offersV2}`;
  }
  if (resource === routes.offersTH && !!customerId) {
    return `${routes.customer}/${customerId}${routes.offersTH}`;
  }
  if (resource === routes.giftCard && !!customerId) {
    return `${routes.customer}/${customerId}${routes.giftCard}`;
  }
  if (resource === routes.supportHistory && !!customerId) {
    return `${routes.customer}/${customerId}${routes.supportHistory}`;
  }
  if (resource === routes.store && !!storeId) {
    return `${routes.store}/${storeId}`;
  }
  if (resource === routes.thLoyalty && !!customerId) {
    return `${routes.customer}/${customerId}${routes.thLoyalty}`;
  }
  return resource;
};
